import React from "react"

import * as styles from "./index.module.scss"

type Props = {
  children: React.ReactNode
  variant?: "light-to-dark" | "dark-to-light"
  size?: "normal" | "small"
}

function SectionFooterCard({ variant, children, size = "normal" }: Props) {
  const isDarkToLight = variant === "dark-to-light"
  return (
    <div className={`${styles.container} ${styles[size]}`}>
      <div
        className={`${styles.background} ${
          isDarkToLight && styles.darkToLight
        }`}
      >
        <div className={styles.topBackground} />
        <div className={styles.bottomBackground} />
      </div>
      <div className={styles.card}>{children}</div>
    </div>
  )
}

export default SectionFooterCard
